import { CustomPageType } from '../../../../../extViewmodels';
import { useCustomPageStyleByType } from '../../../../../queries/CustomPageStyle';

export const useSurveyHeaderCustomizationStatus = () => {
	const customHeaderQuery = useCustomPageStyleByType({
		type: CustomPageType.Header,
		targetPageType: CustomPageType.Survey,
		enabled: true,
	});

	return {
		...customHeaderQuery,
		hasSurveyHeaderCustomization: customHeaderQuery.data?.hasCustomization === true,
	};
};
